module.exports = __webpack_public_path__ + "static/img/ESG02E.8b51322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ESG02E.png
// module id = 6INv
// module chunks = 1